import Radar from 'd3vue/components/Radar.vue'
import { keepDimensions, buildCropFunction, valueAsNumber } from '../dataFilter'
import { toScale } from '../colors'
import api from '../api'

export default {
  id: 'dimension-radar',
  label: 'Radar par dimensions',
  component: Radar,
  multipleMeasure: () => true,
  dimensions: 1,
  adaptater: (data, vue) => {
    let max = null
    let min = null
    const keep = {}
    const dimensions = keepDimensions(1, data)
    const result = vue.measure.map((m, i) => {
      let values = dimensions.map(d => {
        const measure = valueAsNumber(d[api.measure.name(m)])
        if (max === null || measure > max) {
          max = measure
        }
        if (min === null || measure < min) {
          min = measure
        }
        if ((measure || !vue.noEmpty) && typeof keep[d.Group0UniqueName] === 'undefined') {
          keep[d.Group0UniqueName] = true
        }
        return {
          id: d.Group0UniqueName,
          name: d.Group0Caption,
          value: measure
        }
      })
      
      if (!i) {
        values.forEach(v => {
          keep[v.id] = { keep: keep[v.id], crop: true }
        })
        values = buildCropFunction(d => d.value, vue)(values)
        values.forEach(v => {
          keep[v.id].crop = false
        })
        Object.keys(keep).forEach(k => {
          if (typeof keep[k] === 'object') {
            keep[k] = keep[k].keep && !keep[k].crop
          }
        })
      }
      return {
        values,
        title: api.measure.name(m)
      }
    })
    const props = {
      domain: [min, max],
      formatter: vue.buildMeasureFormatter(api.measure.uniqueName(vue.metadata.measures[0]))
    }
    if (vue.colorScheme) {
      props.colorScale = toScale(vue.colorScheme)
    }
    vue.buildProps(props)
    result.forEach(d => {
      d.values = d.values.filter(v => keep[v.id])
    })
    return result
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/DimensionRadar.js